
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Busserviceforcorporatepune() {



    const cardData =
    {
        keyword: 'Bus Service for Corporate Pune',
        heading: 'etravo :  Bus Service for Corporate Pune',
        headingDescription: 'eTravo offers reliable and efficient Bus Service for Corporate Pune, catering to the daily travel needs of employees, executives, and business delegations. Our fleet includes AC and non-AC buses with spacious seating, GPS tracking, and experienced drivers, ensuring safety, punctuality, and comfort. Whether it’s routine employee pick-up and drop, off-site corporate events, training sessions, or group business tours, eTravo provides customizable and scalable transport solutions. Trusted by leading organizations in Pune, we guarantee smooth coordination, flexible scheduling, and top-tier service across all major IT parks, industrial zones, and corporate hubs.',

        top: 'Top Places to Visit in Pune with etravo',
 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "A historic fortification in the heart of Pune, built in 1732 by the Peshwas. Known for its majestic gates and rich Maratha architecture, it remains a symbol of the city’s royal past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, this grand palace is a landmark of historical importance, associated with Mahatma Gandhi's freedom struggle. It features Italian arches and lush gardens."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a hilltop, this ancient fort offers panoramic views and has witnessed many historic battles. It’s a popular trekking and picnic spot near Pune."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, showcasing exquisite carvings and ancient Indian architecture in a serene setting."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Home to a vast collection of Indian artifacts, including musical instruments, paintings, and everyday items, giving a glimpse into India’s rich cultural history."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune's most iconic temples, known for its massive Ganesh idol and spiritual ambiance. It attracts thousands of devotees daily."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort offers tranquility and spiritual wellness, attracting global visitors seeking peace and mindfulness."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Also known as the Japanese Garden, it is modeled after Okayama’s Koraku-en Garden and features lush landscapes, walking paths, and a calming stream."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "A hillock with temples dedicated to Lord Shiva and Goddess Parvati, offering panoramic views of Pune city and a peaceful retreat from the urban rush."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A scenic spot popular for picnics and sunsets, this dam supplies water to Pune and offers beautiful views of the Sahyadri hills and the backwaters."
  }
],


   "services": [
  {
    "name": "Office Bus Hire in Pune",
    "description": "eTravo provides efficient office bus hire services in Pune to help companies streamline employee transport. Our fleet includes well-maintained AC and non-AC buses designed for daily commutes, business park shuttles, and long-term staff transportation contracts. Flexible scheduling and route customization make this ideal for all business sizes."
  },
  {
    "name": "Staff Transport Solutions Pune",
    "description": "eTravo offers tailored staff transport solutions in Pune designed to enhance employee satisfaction and reduce commute-related stress. From office bus hire to employee pickup and drop services, our offerings include AC buses, shuttle services, and customizable route planning. We ensure safety, punctuality, and cost-effectiveness, making corporate transportation seamless and efficient."
  },
  {
    "name": "Corporate Shuttle Bus Service in Pune",
    "description": "Simplify business mobility with eTravo’s corporate shuttle bus services in Pune. Ideal for tech parks and large organizations, our scheduled shuttles help employees commute comfortably and on time. All buses come with trained drivers, GPS tracking, and a dedicated support team to ensure safe and smooth travel."
  },
  {
    "name": "Employee Pickup and Drop Bus Pune",
    "description": "Ensure reliable daily transportation with eTravo’s employee pickup and drop bus services in Pune. Designed for shift workers and office staff, our service includes route optimization, real-time tracking, and punctual operations. Choose between dedicated buses, depending on your company’s staffing needs."
  },
  {
    "name": "Affordable Corporate Bus Rentals Pune",
    "description": "eTravo offers affordable corporate bus rental services in Pune for businesses seeking value without compromising on comfort and reliability. Perfect for daily commutes, company events, or team outings, our cost-effective plans and flexible terms help businesses manage transport budgets smartly."
  },
  {
    "name": "AC Bus for Office Staff in Pune",
    "description": "Travel in comfort with eTravo’s AC bus services for office staff in Pune. Our climate-controlled buses feature clean interiors, ergonomic seating, and professional drivers. Whether you need daily shuttles or on-demand transport, our solutions are crafted to support workforce mobility with style and convenience."
  },
  {
    "name": "Business Travel Bus Services Pune",
    "description": "For business travel needs that require moving teams or clients, eTravo offers dedicated bus services in Pune. Our fleet includes premium AC coaches and minibuses suited for airport transfers, conferences, and corporate retreats. Enjoy dependable scheduling, experienced drivers, and seamless coordination for every journey."
  },
  {
    "name": "Comfortable Bus Hire for Corporates Pune",
    "description": "eTravo provides comfortable bus hire services for corporates in Pune. Our buses are equipped with plush seating, ample legroom, and air-conditioning to ensure a relaxed commute. Ideal for regular office travel, company outings, or intercity team transfers, our service is focused on efficiency and rider comfort."
  }
],
"tableData": [
  ["Office Bus Hire in Pune", "Staff Transport Solutions Pune"],
  ["Corporate Shuttle Bus Service in Pune", "Employee Pickup and Drop Bus Pune"],
  ["Affordable Corporate Bus Rentals Pune", "AC Bus for Office Staff in Pune"],
  ["Business Travel Bus Services Pune", "Comfortable Bus Hire for Corporates Pune"]
],




"whychoose": [
    {
        "WhyChooseheading": "Premium Corporate Bus Services in Pune",
        "WhyChoosedescription": "eTravo offers reliable and high-quality bus services for corporate clients in Pune. Whether it’s daily employee transportation to IT parks or shuttle services for business events, we ensure efficient, safe, and professional group travel across the city."
    },
    {
        "WhyChooseheading": "Modern, Spacious & AC-Equipped Buses",
        "WhyChoosedescription": "Our fleet includes a wide range of modern buses—AC coaches, mini-buses, and large buses—designed to provide comfortable travel for corporate teams. All buses feature clean interiors, comfortable seating, air-conditioning, and optional onboard Wi-Fi and charging points."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our drivers are professionally trained, well-versed in Pune’s corporate zones such as Hinjewadi, Kharadi, Magarpatta, and Baner, and committed to safe driving practices. They ensure punctual pickups and smooth travel, even during peak hours."
    },
    {
        "WhyChooseheading": "On-Time Departures with Real-Time Tracking",
        "WhyChoosedescription": "Time-sensitive commutes are a top priority. eTravo ensures all buses run on schedule with real-time GPS tracking, proactive delay alerts, and coordinated pickup/drop timing to align with company shifts or event schedules."
    },
    {
        "WhyChooseheading": "Corporate Billing with GST-Compliant Invoices",
        "WhyChoosedescription": "We make billing simple for HR and admin teams. eTravo offers transparent pricing, centralized billing options, and detailed, GST-compliant invoices—perfect for tracking travel expenses across departments or cost centers."
    },
    {
        "WhyChooseheading": "24/7 Support for Corporate Transportation Needs",
        "WhyChoosedescription": "Whether it’s early-morning shuttles or late-evening conference transport, our buses are available round the clock to support dynamic corporate schedules. Our operations team is available 24/7 for urgent rescheduling or support."
    },
    {
        "WhyChooseheading": "Simple Scheduling via App, Web, or Phone",
        "WhyChoosedescription": "Booking a corporate bus with eTravo is fast and easy. Use our app, website, or call our dedicated support line to plan your rides. We provide route mapping, driver info, and live updates for a smooth coordination experience."
    },
    {
        "WhyChooseheading": "Tailored Transport Plans for Enterprises",
        "WhyChoosedescription": "From daily office commutes to company-wide offsite transport, eTravo offers customized travel solutions for businesses of all sizes in Pune. We align with your specific needs, routes, and employee shifts to deliver hassle-free transport services."
    }
]



























    }

const faqData = [
    [
        {
            question: 'Does eTravo offer corporate bus services in Pune?',
            answer: 'Yes, eTravo provides reliable and efficient corporate bus services in Pune, ideal for employee transportation, group travel for corporate events, and inter-office shuttle services.',
        },
        {
            question: 'What types of buses are available for corporate travel in Pune?',
            answer: 'We offer a fleet of well-maintained buses including mini-buses, tempo travellers, and full-sized AC coaches. Each comes with comfortable seating, experienced drivers, and route flexibility.',
        },
        {
            question: 'Can eTravo handle daily employee transport via buses in Pune?',
            answer: 'Absolutely. We provide scheduled employee bus services with fixed routes, pickup points, and real-time tracking to ensure punctual and safe commuting for your workforce in Pune.',
        },
        {
            question: 'Are your corporate buses equipped with safety and tracking features?',
            answer: 'Yes, all buses are GPS-enabled and monitored in real-time. Clients have access to live tracking, trip logs, and automated reporting for better oversight and employee safety.',
        },
        {
            question: 'Can we book buses for corporate events or group travel in Pune?',
            answer: 'Yes, our flexible bus service covers transportation for conferences, training programs, site visits, and team outings, ensuring smooth and coordinated group travel.',
        },
        {
            question: 'Is there dedicated support for managing corporate bus logistics in Pune?',
            answer: 'Yes, corporate clients receive a dedicated transport coordinator for route planning, scheduling, driver communication, and daily operations management in Pune.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Kulkarni',
        designation: 'Facility Manager, TechNova Systems Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s corporate bus service in Pune has streamlined our employee transport. The buses are clean, punctual, and the tracking system gives us complete peace of mind.”',
    },
    {
        name: 'Ms. Priya Menon',
        designation: 'HR Executive, BrightEdge Technologies',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo’s bus service for our office commute and team outings in Pune. Their service is professional, reliable, and the staff coordination is excellent.”',
    },
];

















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Service for Corporate Pune",
  "image": "https://www.etravo.in/images/keyword/corporate-bus-pune.jpg",
  "description": "Professional corporate bus services in Pune by eTravo. Ideal for office bus hire, staff transport, employee pickup and drop, and business travel with AC buses for comfortable and affordable commutes.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/bus-service-for-corporate-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Bus Service for Corporate Pune | Office Transport & Shuttle Hire | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate bus services in Pune with eTravo for staff transport, office bus rental, employee pickup and drop, and business travel. AC buses, affordable rates, and reliable service for companies in Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/25.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busserviceforcorporatepune;